import { Contractor } from "pmt-types/src/models/Contractor.ts";
import { useMutationSearchEntities } from "./useMutationSearchEntities.ts";

export const useMutationSearchSources = () =>
  useMutationSearchEntities<Contractor>("sources");
